import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import gradient from "../../Assets/banner-blue-pill.png";
import StartConversationBlock from '../StartConversationBlock';
import MakesWork from "./MakesWork";

import ServiceCards from "./ServiceCards"
import ServiceSlider from "./ServiceSlider"
import Image from 'react-bootstrap/Image';

export default function Service() {
    return (
        <div>
            <section className='bg-theme section-hero'>
                <Container className="header-section py-5">
                    <Row>
                        <Row className='mb-4'>
                            <Col md={9}>
                                <h2 className="heading-style-h2 pb-3 text-white"><span className="text-gradient-1">Software Development </span>Services</h2>
                                <h5 className='heading-style-h5 pb-5 text-white'>From custom applications to offshore teams, we help you build, run and support software that continues to work as your business evolves.</h5>
                            </Col>
                        </Row>
                        <div className="pills-wrap">

                            <div className="hero-pill-right-wrap animation_slide-up-delay-2">
                                <Image src={gradient} />
                            </div>
                        </div>
                    </Row>
                </Container >
            </section >
            <ServiceCards />
            <StartConversationBlock />
            <MakesWork />
            <ServiceSlider />
        </div >
    )
}
